/**
 * Global "hide" switches that are NOT package features: one build-time flag per surface family, so a feature that is not ready for customers
 * can be hidden everywhere at once (and brought back by flipping the flag + a redeploy), without touching any package.
 *
 * REACT_APP_HIDE_FIXTURE_MATCH=true hides the two fixture-based schedulers (Match scheduler = /apps/match-scheduler, Smart ad scheduler = /apps/smart-ad-scheduler):
 * their sidebar entries, schedule tiles, chips, the landing-page tile + pricing rows, the plan-comparison rows, and the routes (a deep link goes to /schedule).
 * Backend routes and package flags are untouched. Evaluated at CALL time so tests can flip it.
 */
export const fixtureMatchHidden = () => process.env.REACT_APP_HIDE_FIXTURE_MATCH === 'true';

export const FIXTURE_MATCH_FEATURES = ['match_scheduler', 'smart_ad_scheduler', 'smart_ads'];
export const FIXTURE_MATCH_PATHS = ['/apps/match-scheduler', '/apps/smart-ad-scheduler'];
